function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1264",
  "data-name": "Rectangle 1264",
  width: 34.123,
  height: 27.186,
  fill: "#102655"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3115",
  "data-name": "Group 3115",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5122",
  "data-name": "Path 5122",
  d: "M15.481,37.419a2.893,2.893,0,1,1,2.893-2.893,2.9,2.9,0,0,1-2.893,2.893m0-4.636a1.743,1.743,0,1,0,1.743,1.743,1.745,1.745,0,0,0-1.743-1.743",
  transform: "translate(-4.072 -10.233)",
  fill: "#102655"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5123",
  "data-name": "Path 5123",
  d: "M40.423,37.419a2.893,2.893,0,1,1,2.893-2.893,2.9,2.9,0,0,1-2.893,2.893m0-4.636a1.743,1.743,0,1,0,1.743,1.743,1.745,1.745,0,0,0-1.743-1.743",
  transform: "translate(-12.141 -10.233)",
  fill: "#102655"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5124",
  "data-name": "Path 5124",
  d: "M29.617,18.947H11.166a.574.574,0,0,1-.562-.457L7.293,2.8.44,1.134A.575.575,0,0,1,.71.016L7.917,1.763a.576.576,0,0,1,.428.44L11.633,17.8H29.185l3.6-12.5H12.149a.575.575,0,1,1,0-1.15h21.4a.575.575,0,0,1,.552.734L30.17,18.531a.574.574,0,0,1-.552.416",
  transform: "translate(0 0)",
  fill: "#102655"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5125",
  "data-name": "Path 5125",
  d: "M35.465,14.062h-13.1a.575.575,0,1,1,0-1.15h13.1a.575.575,0,0,1,0,1.15",
  transform: "translate(-7.048 -4.177)",
  fill: "#102655"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5126",
  "data-name": "Path 5126",
  d: "M35.626,20.84h-9.39a.575.575,0,1,1,0-1.15h9.39a.575.575,0,1,1,0,1.15",
  transform: "translate(-8.301 -6.37)",
  fill: "#102655"
}));

var SvgShoppingCart = function SvgShoppingCart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34.123,
    height: 27.186,
    viewBox: "0 0 34.123 27.186",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart.d95bd02a.svg";
export { ForwardRef as ReactComponent };